export class Banner {
  bannerId?: number
  imageUrl!: string
  title!: string
  description: string = ''
  transitionPageUrl: string = ''
  startDate: Date | null = null
  endDate: Date | null = null
}
